<router-outlet *ngIf="initialized"></router-outlet>
